import React, { Component } from "react";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleInput from "../../../../../modules/SimpleInput";
import InputWithButton from "../inputWithButton";
import { ACTIVITY_TYPE } from "../../../../common/Constants";

export default class CustomerInformationSection extends Component {
  checkIsDisabled = () => {
    const { activityType, isDisableSpesificField } = this.props;

    const isView = activityType === ACTIVITY_TYPE.VIEW;
    const isDelete = activityType === ACTIVITY_TYPE.DELETE;
    const isUpdate = activityType === ACTIVITY_TYPE.UPDATE;
    
    if (isView || isDelete) {
      return isView || isDelete;
    }
    if (isUpdate) {
      return isDisableSpesificField;
    }
  };
  render() {
    const {
      provinceOptions,
      setValue,
      controls,
      kabkotOptions,
      kecamatanOptions,
      kelurahanOptions,
      zipCodeOptions,
      onOpenModalDataCustomer,
      onResetLocationOptions,
      errors,
      onCheckNIK,
      isAutoPopulatedData,
    } = this.props;
    const isDisable = this.checkIsDisabled() || isAutoPopulatedData;
    return (
      <React.Fragment>
        <div className="grid grid-3x gap-30px">
          <div className="column-1">
            <InputWithButton
              id="id_nama_pemilik_input"
              label="Nama Pemilik"
              mandatory
              errorMessage={errors?.namaPemilik}
              icon={<i className="fa fa-md fa-search" />}
              name="namaPemilik"
              disableInput={isDisable}
              disableButton={isDisable}
              value={controls?.namaPemilik?.value}
              onClickIcon={onOpenModalDataCustomer}
              onChange={({ target }) => setValue(target.name, target.value)}
            />
            <InputWithButton
              id="id_nik"
              label="NIK"
              buttonText="CEK"
              name="nik"
              disableInput={isDisable}
              disableButton={
                controls?.tipePengajuan?.value?.value === "C1" || isDisable
              }
              mandatory={controls?.tipePengajuan?.value?.value !== "C1"}
              errorMessage={errors?.tipePengajuan}
              value={controls?.nik?.value}
              onClickIcon={() => onCheckNIK(controls?.nik?.value)}
              onChange={({ target }) => setValue(target.name, target.value)}
            />
            <SimpleInput
              id="id_address_input"
              label="Alamat"
              name="alamat"
              mandatory
              readOnly={isDisable}
              errorMessage={errors?.alamat}
              value={controls?.alamat?.value}
              onChange={({ target }) => setValue(target.name, target.value)}
            />
            <SimpleDDL
              id="id_dropdown_province"
              label="Provinsi"
              name="province"
              box="search"
              mandatory
              readOnly={isDisable}
              errorMessage={errors?.province}
              options={provinceOptions}
              value={controls?.province?.value}
              onChange={(value, { name }) => {
                onResetLocationOptions("province");
                this.props.setValue(name, value);
              }}
            />
          </div>

          <div className="column-2">
            <SimpleDDL
              id="id_dropdown_kabkot"
              label="Kota/Kabupaten"
              name="kabkot"
              box="search"
              mandatory
              readOnly={isDisable}
              errorMessage={errors?.kabkot}
              options={kabkotOptions}
              value={controls?.kabkot?.value}
              onChange={(value, { name }) => {
                setValue(name, value);
                onResetLocationOptions("kabkot");
              }}
            />
            <SimpleDDL
              id="id_dropdown_kecamatan"
              label="Kecamatan"
              name="kecamatan"
              mandatory
              readOnly={isDisable}
              errorMessage={errors?.kecamatan}
              box="search"
              options={kecamatanOptions}
              value={controls?.kecamatan?.value}
              onChange={(value, { name }) => {
                onResetLocationOptions("kecamatan");
                setValue(name, value);
              }}
            />
            <SimpleDDL
              id="id_dropdown_kelurahan"
              label="Kelurahan"
              name="kelurahan"
              mandatory
              errorMessage={errors?.kelurahan}
              box="search"
              readOnly={isDisable}
              options={kelurahanOptions}
              value={controls?.kelurahan?.value}
              onChange={(value, { name }) => setValue(name, value)}
            />
            <SimpleDDL
              id="id_dropdown_kodepos"
              label="Kode Pos"
              name="zipcode"
              mandatory
              readOnly={isDisable}
              errorMessage={errors?.zipcode}
              box="search"
              options={zipCodeOptions}
              value={controls?.zipcode?.value}
              onChange={(value, { name }) => setValue(name, value)}
            />
          </div>

          <div className="column-3">
            <SimpleInput
              id="id_input_member_id"
              label="Member ID"
              name="memberId"
              readOnly={isDisable}
              value={controls?.memberId?.value}
              onChange={({ target }) => setValue(target.name, target.value)}
            />
            <SimpleInput
              id="id_input_nomor_hp_1"
              label="Nomor HP 1"
              mandatory
              errorMessage={errors?.nomorHp1}
              name="nomorHp1"
              value={controls?.nomorHp1?.value}
              readOnly={isDisable}
              onChange={({ target }) => setValue(target.name, target.value)}
            />
            <SimpleInput
              id="id_input_nomor_hp_2"
              label="Nomor HP 2"
              name="nomorHp2"
              readOnly={isDisable}
              value={controls?.nomorHp2?.value}
              onChange={({ target }) => setValue(target.name, target.value)}
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
}
